import React from "react";
import { SignupFlow } from "@/features/signup";

/**
 * SignupPage - 회원가입 페이지
 * SignupFlow 컴포넌트를 렌더링합니다
 */
export const SignupPage = () => {
  return <SignupFlow />;
};
